<script setup>
import Navigation from './components/Navigation.vue'
import Hero from './components/Hero.vue'
import CodeExample from './components/CodeExample.vue'
import MetricsBar from './components/MetricsBar.vue'
import ProductGrid from './components/ProductGrid.vue'
import HowItWorks from './components/HowItWorks.vue'
import WaitlistForm from './components/WaitlistForm.vue'
import Footer from './components/Footer.vue'
</script>

<template>
  <div class="min-h-screen bg-white">
    <Navigation />
    <Hero />
    <CodeExample />
    <MetricsBar />
    <ProductGrid />
    <HowItWorks />
    <WaitlistForm />
    <Footer />
  </div>
</template>
